// ---------------------------------------------------------------------------
// dates — client-side date formatting.
//
// The engine registers no `date` Nunjucks filter (and the theme can't add
// one). Templates emit raw ISO dates as `<time datetime="2026-01-31">…</time>`
// and this module fills the visible text using Intl.DateTimeFormat.
// Opt out per-element with `data-date-format="none"`; override the locale
// preset with `data-date-format="short"`.
// ---------------------------------------------------------------------------

const presets: Record<string, Intl.DateTimeFormatOptions> = {
	long: { year: 'numeric', month: 'long', day: 'numeric' },
	short: { year: 'numeric', month: 'short', day: 'numeric' },
};

export const initDates = (): void => {
	const nodes = document.querySelectorAll<HTMLTimeElement>('time[datetime]');
	for (const el of nodes) {
		const preset = el.dataset.dateFormat ?? 'long';
		if (preset === 'none') continue;
		const iso = el.getAttribute('datetime');
		if (!iso) continue;
		const date = new Date(iso);
		if (Number.isNaN(date.getTime())) continue;
		el.textContent = new Intl.DateTimeFormat(undefined, presets[preset] ?? presets.long).format(
			date,
		);
	}
};
